module.exports = __webpack_public_path__ + "img/Setaria_italica.2b13f2a7.jpg";